import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { FileExtension } from '../../models/product-data-filename-conventions/file-extension';
import { PreviewProductDataResult } from '../../models/product-data-preview/preview-product-data-result';

@Injectable({
  providedIn: 'root',
})
export class ProductDataPreviewService {
  constructor(private http: HttpClient) {}

  preview(productIds: string[], formats: FileExtension[]): Observable<PreviewProductDataResult> {
    const url = `${environment.apiBase}/product-data/preview`;
    return this.http.post<PreviewProductDataResult>(url, {
      productIds,
      target: { formats },
    });
  }
}
